module.exports = __webpack_public_path__ + "img/meditation_100--active.31eba177.svg";